import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {Conf} from '../settings/config';
import 'rxjs/add/operator/map';
import {AuthServices} from './auth.service';
import {User} from '../models/user.model';

@Injectable()
export class ApiService {
    authUser: User;

    constructor(private http: HttpClient,
                private authService: AuthServices) {
        this.authService.currentUser.subscribe((user: User) => this.authUser = user);
    }

    getEssentialCategories(): Observable<any> {
        return this.http
            .get(`${Conf.API_URL}/get-categories-essentials/`)
            .map(categories => categories);
    }

    getEssentials(next: string): Observable<any> {
        const url = next ? next : `${Conf.API_URL}/essentials/`;
        return this.http
            .get(url)
            .map(essentials => essentials);
    }

    getEssentialsByCategorySlug(categorySlug: string, next: string): Observable<any> {
        const url = next ? next : `${Conf.API_URL}/essentials/?category__slug=${categorySlug}`;
        return this.http
            .get(url)
            .map(essentials => essentials);
    }

    getRestaurantBySlug(slug: string): Observable<any> {
        return this.http
            .get(`${Conf.API_URL}/restaurants/?slug=${slug}`)
            .map(res => res);
    }

    getRestaurantReviewsAvg(url: string): Observable<any> {
        return this.http
            .get(url)
            .map(res => res);
    }

    getRestaurantReviews(url: string): Observable<any> {
        return this.http
            .get(url)
            .map(res => res);
    }

    getRestaurantImages(slug: string): Observable<any> {
        return this.http
            .get(`${Conf.API_URL}/restaurant-images/?restaurant__slug=${slug}`)
            .map(res => res);
    }

    getRestaurantFacilities(id: number): Observable<any> {
        return this.http
            .get(`${Conf.API_URL}/restaurant-facilities-in-groups/?restaurant=${id}`)
            .map(res => res);
    }

    loadMore(next: string): Observable<any> {
        return this.http
            .get(next)
            .map(res => res);
    }

    getNearby(slug: string): Observable<any> {
        return this.http
            .get(`${Conf.API_URL}/restaurant-nearby-properties/?category=all&slug=${slug}`)
            .map(res => res);
    }

    postRestaurantReview(body: any): Observable<any> {
        const headers = new HttpHeaders({'Authorization': `Token ${this.authUser.token}`});

        return this.http
            .post(`${Conf.API_URL}/restaurant-reviews/`, body, {headers})
            .map(res => res);

    }

    getRestaurantMenu(id: number): Observable<any> {
        return this.http
            .get(`${Conf.API_URL}/menus/?restaurant=${id}`)
            .map(res => res);
    }

    getSeatingAreas(slug: string): Observable<any> {
        return this.http
            .get(`${Conf.API_URL}/seating-areas/?restaurant__slug=${slug}`)
            .map(res => res);
    }
}



// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/services/api.service.ts